import { Input } from "antd";
import { OFMultiSelect } from "../../OFMultiselect/OFMultiSelect";
import { translateKey as t } from "../../../locales/translation";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown, faFilter } from "@fortawesome/free-solid-svg-icons";

const CardSearchFilter = ({ column, handleFilter }) => {
  return (
    <div className="flex">
      <div className="globalSearch" style={{ width: "calc(100% - 60px)" }}>
        {renderDropDown(column)}
        <Input
          size="small"
          placeholder={t("lblSearchTheTable", "Search the table")}
          onChange={(e) => handleInputChange(column, e.target.value, handleFilter)}
          value={column.filterValue || column.finalFilterValue}
          onPressEnter={() => handleFilter(column, "default")}
          className="searchInput"
          allowClear={true}
          // style={{ top: -1 }}
        />
      </div>
    </div>
  );
};

const renderDropDown = (column) => {
  return (
    <OFMultiSelect
      data={column.options}
      renderItem={(item: any) => item.name}
      selectedItems={column.selectedCols}
      menuWidth={200}
      onSelect={(val, state, selectedAll) => handleSelection(val, state, selectedAll, column)}
      btnPlaceholder={
        <>
          <FontAwesomeIcon icon={faFilter} /> ({column.selectedCols.length})
          <FontAwesomeIcon icon={faAngleDown} style={{ marginLeft: 4 }} />
        </>
      }
      canSelectAll={true}
      size="small"
      style={{
        borderBottomRightRadius: 0,
        borderTopRightRadius: 0,
        marginRight: -1,
        borderColor: "#40a9ff",
        flex: 0,
      }}
    />
  );
};

const handleSelection = (val, state, selectedAll, column) => {
  if (state) {
    if (selectedAll) {
      column.selectedCols = column.options.map((depot) => depot._id);
    } else {
      column.selectedCols.push(val._id);
    }
  } else {
    if (selectedAll) {
      column.selectedCols = [];
    } else {
      const itemIndex = column.selectedCols.findIndex((item) => item === val._id);
      column.selectedCols.splice(itemIndex, 1);
    }
  }
};

const handleInputChange = (column, value, handleFilter) => {
  // If there were no previous values and the user types only space, we ignore that
  if (!column.filterValue && !value.trim()) {
    return;
  }

  column.filterValue = !value.trim() ? "" : value;

  if (!column.filterValue) {
    handleFilter(column, "default");
  }

  if (!column.filterOnSubmit) {
    column.finalFilterValue = !value.trim() ? "" : value;
  }
};

const FilteringMethod = (currentRow, query, data, colId, column) => {
  if (column?.selectedCols.length > 0) {
    let found = false;

    column.selectedCols.forEach((colId) => {
      if (
        currentRow &&
        typeof currentRow[colId] === "string" &&
        currentRow[colId].toLocaleLowerCase().includes(query.toLocaleLowerCase())
      ) {
        found = true;
      }
    });
    return found;
  }

  return true;
};

export { CardSearchFilter, FilteringMethod };
